export const FaceDatabase = {
  title: "Gestión de Bases de Datos de Rostros",
  database: "Base de Datos de Rostros",
  databases: "Bases de Datos de Rostros",
  subject: "Persona",
  subjects: "Personas",
  image: "Imagen",
  images: "Imágenes",
  create: "Crear",
  edit: "Editar",
  delete: "Eliminar",
  save: "Guardar",
  cancel: "Cancelar",
  upload: "Subir",
  name: "Nombre",
  description: "Descripción",
  gender: "Género",
  nationality: "Nacionalidad",
  required: "Requerido",
  searchSubjects: "Buscar personas...",
  noResultsFound: "No se encontraron resultados",
  tryDifferentSearch: "Intenta ajustar tus términos de búsqueda",
  confirmDelete: '¿Estás seguro de que quieres eliminar "{name}"?',
  maxImages: "Máximo 10 imágenes por persona",
  imageLimit: "Límite de imágenes alcanzado",
  noSubjects: "No hay personas en esta base de datos",
  noImages: "No hay imágenes para esta persona",
  noDatabases: "No hay bases de datos de rostros disponibles",
  createDatabase: "Crear Base de Datos de Rostros",
  createSubject: "Crear Persona",
  linkExistingSubject: "Vincular Persona Existente",
  selectExistingSubjects: "Personas del proyecto",
  loadingProjectSubjects: "Cargando personas del proyecto...",
  noLinkableSubjects: "No hay personas del proyecto disponibles para vincular",
  linkExistingSubjectHelp:
    "{count} personas de este proyecto están disponibles para vincular a esta base de datos.",
  uploadImages: "Subir Imágenes",
  selectDatabase: "Selecciona una base de datos para ver su contenido",
  selectSubject: "Selecciona una persona para ver sus imágenes",
  databaseName: "Nombre de la Base de Datos",
  databaseType: "Tipo de Base de Datos",
  personName: "Nombre de la Persona",
  dropImages: "Arrastra imágenes aquí o haz clic para seleccionar",
  dragImages: "Arrastra imágenes aquí",
  processing: "Procesando...",
  detecting: "Detectando rostros...",
  facesDetected: "Rostros detectados",
  noFacesDetected: "No se detectaron rostros",
  noFacesDetectedDescription:
    'Este detector funciona mejor con rostros cercanos o que ocupen buena parte de la foto. <ul style="padding-left: 15px"><li>Prueba subiendo una imagen con rostros más grandes o cercanos.</li><li>O dibuja manualmente las áreas de rostro en la imagen.</li></ul>',
  faceDetection: "Detección de Rostros",
  assignFace: "Asignar rostro a persona",
  editBoundingBox: "Editar caja delimitadora",
  deleteBoundingBox: "Eliminar caja delimitadora",
  drawBoundingBox: "Dibujar caja delimitadora",
  confirmUpload: "Confirmar subida",
  imageMetadata: "Metadatos de Imagen",
  fileName: "Nombre del Archivo",
  dimensions: "Dimensiones",
  fileSize: "Tamaño del Archivo",
  created: "Creado",
  lastModified: "Última Modificación",
  hash: "Hash",
  goBack: "Volver",
  selectImages: "Seleccionar Imágenes",
  addBoundingBoxManually: "Añadir rostros manualmente",
  saveAnnotations: "Guardar Anotaciones",
  noFacesAssignedToUpload: "No hay rostros asignados para subir",
  createNewPerson: "Crear nueva persona",
  assignedTo: "Asignado a",
  confidence: "Confianza",
  assignToPerson: "Asignar a persona",
  databaseNotFound: "Base de datos no encontrada",
  multipleImageSupport:
    "Soporte para una sola imagen o múltiples. Sin límite de tamaño para las imágenes originales.",
  addMoreImages: "Agregar más imágenes",
  imagesLoaded: "Imágenes cargadas",
  processFaces: "Procesar rostros",
  noFacesDetectedInImage: "No se detectaron rostros en esta imagen",
  facesDetectedSuffix: "rostros detectados",
  selectImageToProcess: "Selecciona una imagen para procesar los rostros",
  removeSubjectAction: "Quitar persona",
  duplicateSubjectTitle: "La persona ya existe",
  duplicateSubjectPrompt:
    'Ya existe una persona llamada "{name}" en este proyecto. ¿Quieres vincular esa persona existente a esta base de datos en lugar de crear una nueva?',
  externalEngineRegistrationInfo:
    "Esta base de datos está conectada a {engine}. Al crear o vincular una persona se registrará en el motor externo y puede tardar un momento.",
  removeSubjectUnlink:
    'Esto quitará a "{name}" de esta base de datos. La persona y sus imágenes se conservarán porque sigue perteneciendo a otras bases de datos.',
  removeSubjectDelete:
    'Esto eliminará permanentemente a "{name}" y todas sus imágenes asociadas porque esta es la última base de datos vinculada a esta persona.',
  removeSubjectExternalEngine:
    "Si esta era la última base de datos de tipo {engine} vinculada a esta persona, también se eliminará del motor externo de reconocimiento.",
  confirmUnlinkSubject:
    '¿Estás seguro de que quieres desvincular a "{name}"? Si esta persona no está vinculada a ninguna otra base de datos, será eliminada.',
  confirmDeleteImageTitle: "Eliminar Rostro",
  confirmDeleteImage:
    "¿Estás seguro de que quieres eliminar este rostro? Esta acción no se puede deshacer.",
  helpTooltip:
    "Puedes arrastrar el cursor para dibujar cajas delimitadoras alrededor de los rostros. Haz clic para editar o eliminar las cajas existentes.",
  manualCrop: "Manual",
  editedCrop: "Editado",
  reAnalizeFaces: "Reanalizar rostros",
  removeImage: "Eliminar Imagen",
  retryUpload: "Reintentar",
  uploadErrors: "Errores de Subida",
  errors: {
    invalidFormat:
      "Formato de imagen inválido. Solo se permiten archivos JPEG.",
    invalidSize: "Tamaño de imagen inválido. Deben medir al menos 36x36 px.",
    fileTooBig: "Archivo demasiado grande. El tamaño máximo es 100KB.",
    tooManyImages: "Demasiadas imágenes. Máximo 10 imágenes por persona.",
    uploadFailed: "Error al subir imágenes",
    deleteFailed: "Error al eliminar imagen",
    createFailed: "Error al crear",
    updateFailed: "Error al actualizar",
    unlinkFailed: "Error al desvincular persona",
    removeFailed: "Error al quitar la persona de la base de datos",
    linkFailed: "Error al vincular la persona a la base de datos",
    loadFailed: "Error al cargar datos",
    nameTooLong: "El nombre es demasiado largo. Máximo 255 caracteres.",
    nameRequired: "El nombre es requerido",
    descriptionTooLong:
      "La descripción es demasiado larga. Máximo 500 caracteres.",
    nationalityTooLong:
      "La nacionalidad es demasiado larga. Máximo 100 caracteres.",
    bboxTooSmall: "Caja delimitadora demasiado pequeña. Tamaño mínimo 36px.",
    errorUploadingImages: "Error al subir las imágenes",
    errorLoadingDatabases: "Error al cargar las bases de datos de rostros",
    errorLoadingSubjects: "Error al cargar los sujetos",
    errorLoadingImages: "Error al cargar las imágenes",
    reDetectionFailed: "Error al re-detectar rostros",
    duplicateName: "Ya existe una persona con ese nombre en este proyecto.",
    duplicateAlreadyLinked:
      "Ya existe una persona con ese nombre y ya está vinculada a esta base de datos.",
    subjectProjectMismatch:
      "Esta persona pertenece a otro proyecto y no puede vincularse aquí.",
    incompatibleEngineType:
      "Esta persona está registrada con {subjectEngineType} y no puede vincularse a una base de datos de tipo {databaseType}.",
    syncFailed: "Error al sincronizar la persona con el motor externo",
    partialUpload:
      "Se subieron exitosamente {successCount} imágenes, pero {errorCount} fallaron.",
  },
  success: {
    uploaded: "Imágenes subidas exitosamente",
    deleted: "Imagen eliminada exitosamente",
    created: "Creado exitosamente",
    updated: "Actualizado exitosamente",
    imagesUploadedSuccessfully: "Imágenes subidas exitosamente",
    facesReDetected: "Rostros re-detectados exitosamente",
    subjectLinked: "Persona vinculada exitosamente",
    subjectsLinked: "Se vincularon exitosamente {count} personas",
    subjectRemoved: "Persona quitada de esta base de datos",
    subjectDeleted: "Persona e imágenes eliminadas permanentemente",
    subjectSynced: "Persona sincronizada exitosamente",
    existingSubjectSelected: "Se seleccionó la persona existente",
  },
  databaseTypes: {
    DEFAULT: "Estandar",
    SEVENTH_SENSE: "Seventh Sense",
  },
  engineTypes: {
    DEFAULT: "Estandar",
    SEVENTH_SENSE: "Seventh Sense",
  },
  genderOptions: {
    MALE: "Masculino",
    FEMALE: "Femenino",
    OTHER: "Otro",
    UNSPECIFIED: "No especificado",
  },
  sync: {
    action: "Sincronizar persona",
    states: {
      SYNCHRONIZING: "Sincronizando ...",
      OK: "Sincronizada",
      ERROR: "Se necesita sincronización",
      ERROR_ON_SYNC: "Error durante la sincronización, reintentar",
      UNKNOWN_STATE: "Estado desconocido",
    },
    notification: {
      message: "Sincronizando",
      description1: "Inicia la sincronización con ",
      description2: ".",
    },
  },
};
